import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class ScoringSystems extends BaseModel {
  constructor() {
    super(collection(db, 'scoring_systems'))
  }
}
